import {Component, Inject} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MAT_DIALOG_DATA, MatDialogClose} from '@angular/material/dialog';
import {PrlTranslateService} from '../../../../shared/services/prl-translate.service';

@Component({
    selector: 'prl-zone-preview-dialog',
    standalone: true,
    imports: [CommonModule, MatDialogClose],
    templateUrl: './prl-zone-preview-dialog.component.html',
    styleUrl: './prl-zone-preview-dialog.component.scss',
})
export class PrlZonePreviewDialogComponent {
    imageError = false;

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: {
            title: string;
            previewUrl: string;
            typeName: string;
            defaultThumbnailClass: string;
        },
        protected readonly translateService: PrlTranslateService
    ) {
    }
}